import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingPaymentListComponent } from './billing-payment-list/billing-payment-list.component';
import { ComponentsModule } from '@fi-app/components/components.module';
import { BusinessUnitInvoiceInformationViewComponent } from './business-unit-invoice-information-view/business-unit-invoice-information-view.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { BusinessUnitCreditCardInformationViewComponent } from './business-unit-credit-card-information-view/business-unit-credit-card-information-view.component';
import { BusinessUnitCreditCardInformationEditComponent } from './business-unit-credit-card-information-edit/business-unit-credit-card-information-edit.component';
import { BusinessUnitInvoiceInformationEditComponent } from './business-unit-invoice-information-edit/business-unit-invoice-information-edit.component';
import { FormsModule } from '@angular/forms';
import { BillingComponentsModule } from '../billing-components/billing-components.module';
import { MatRadioModule } from '@angular/material/radio';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { MatCardModule } from '@angular/material/card';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        UtilitiesModule,
        BillingComponentsModule,
        MatRadioModule,
        FiPageHeaderModule,
        FiPageHeaderButtonGroupModule,
        MatCardModule,
        SelectSearchModule,
        MatFormFieldModule,
        MatInputModule,
        FiErrorMessageModule,
    ],
    declarations: [
        BillingPaymentListComponent,
        BusinessUnitInvoiceInformationViewComponent,
        BusinessUnitInvoiceInformationEditComponent,
        BusinessUnitCreditCardInformationViewComponent,
        BusinessUnitCreditCardInformationEditComponent,
    ],
})
export class BillingPaymentModule {}
